import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';

const apiURL = environment.apiURL;

@Injectable({
  providedIn: 'root'
})
export class MetaService {

  constructor(private http: HttpClient) { }

  getMetaData() {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/meta`, {});
  }
}
